export const company =
{
    name: 'REMAX Executive Homes',
    welcomeName: 'executive-homes.biz',
    mainServiceArea: 'Bangkok',
    phone1: '+66 2-391-8645 (Business Hours)',
    phone2: '+66 81-823-0785 (After Hours)',
    navPhone: '+66 2-391-8645',
    email: 'sales@executive-homes.biz',
    address1: 'Unit 3A, KC Court, Thong Lo 13',
    address2: 'Bangkok, Thailand 10110',
    phoneUrl: 'tel:006623918645',
    lineUrl: 'https://page.line.me/lkw3948e',
    whatsappUrl: '',
    facebookUrl: 'https://www.facebook.com/REMAXExecutiveHomes',
    instagramUrl: 'https://www.instagram.com/executivehomes_business',
    linkedInUrl: 'https://www.linkedin.com/company/executive-homes-bangkok/',
    tiktokUrl: '',
    youtubeUrl: 'https://www.youtube.com/channel/UC-pR-Zg5j9qfUZg4qRk8y8Q',
}
